import React from 'react';

import { Text, Icon, Button, linkAnchorClass, Label } from 'Modules/ui2/components';
import warning from 'Modules/ui2/icons/warning.sprite.svg';

import success from './success.sprite.svg';
import commonStyles from '../common.module.scss';
import styles from './index.module.scss';


export const SuccessfulRegistrationComponent = ({ t, email }) => (
    <>
        <Icon icon={success} className={styles.successIcon} size='56' />
        <Label component='h3' weight='demibold' textSize='21-24'>
            {t('success.title')}
        </Label>
        <Text component='p' className={commonStyles.description} textSize='18'>
            {t('success.description', { email, linkClass: linkAnchorClass })}
        </Text>
    </>
);

export const FailedRegistrationComponent = ({ t, error, setStage }) => (
    <>
        <Icon icon={warning} className={commonStyles.errorIcon} size='48' />
        <Label component='h3' weight='demibold' textSize='21-24'>
            {t('failure.title')}
        </Label>
        <Text component='p' className={commonStyles.description} textSize='18'>
            {error}
        </Text>
        <Text component='p' className={commonStyles.description} textSize='18'>
            {t('failure.description')}
        </Text>
        <Button
            variant='normal'
            className={commonStyles.button}
            size='56'
            type='button'
            onClick={() => setStage('form')}
        >
            {t('failure.backToForm')}
        </Button>
    </>
);
